"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const papaparse_1 = __importDefault(require("papaparse"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const helpers_1 = require("./helpers");
const checkPreErrors = (transformation) => {
    // At the moment, just checking against formulas and available formulas
    // for FormulaEngine usage when assessing output dataTape
    const { filterFormula, srcDataTape } = transformation;
    const errors = [];
    const availableVariables = new Set();
    for (const { field } of srcDataTape.baseFields) {
        availableVariables.add(field);
    }
    const { errorMessages } = (0, formula_engine_1.getFormulaErrors)(filterFormula, availableVariables);
    for (const message of errorMessages) {
        errors.push({ type: 'metadataValidation', message });
    }
    return errors;
};
const getOutputDataTape = (transformation) => {
    const preErrors = checkPreErrors(transformation);
    if (preErrors.length) {
        throw preErrors;
    }
    // Since only just filtering the rows down and not impacting
    // any actual fields or values, can just return provided srcDataTape
    return transformation.srcDataTape;
};
const processFilter = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { formulaEngine, transformation, inputCsvString } = params;
    const preErrors = checkPreErrors(transformation);
    if (preErrors.length) {
        return { errors: preErrors, outputData: [] };
    }
    const baseParseConfig = Object.assign(Object.assign({}, common_1.csvConversion.NEWLINE_PARSE_CONFIG), { delimiter: ',', quoteChar: '"', escapeChar: '"', header: true, skipEmptyLines: true });
    // Set up functionality to stream the CSV string to help manage data sizing
    // This provides us additional flexibility and configuration as "papaparse"
    // also gives us ability to utilize worker threads, if needed
    const csvStreamPromise = new Promise((resolve) => {
        const outputData = [];
        const outputErrors = [];
        papaparse_1.default.parse(inputCsvString, Object.assign(Object.assign({}, baseParseConfig), { 
            // This function will be called for each line in the file
            step(result, parser) {
                const { data, errors, meta } = result;
                if (errors.length) {
                    for (const { message, row } of errors) {
                        outputErrors.push({
                            type: 'filterValidation',
                            message,
                            row,
                        });
                    }
                    resolve({ outputData, outputErrors });
                    parser.abort(); // stop the stream since there's an error
                    return;
                }
                // Set variables for row of data that is being focused on
                // Then run provided filter formula for that data row to evaluate
                // if it should still be added (passes filter)
                try {
                    formulaEngine.setVariables(data);
                    const isDataFilterCompliant = formulaEngine.evaluateBoolean(transformation.filterFormula);
                    if (isDataFilterCompliant) {
                        outputData.push(data);
                    }
                }
                catch (error) {
                    // eslint-disable-next-line no-console
                    console.log({
                        type: 'formulaValidation',
                        message: `Failed formula calculation for ${transformation.filterFormula}`,
                        row: meta.cursor,
                        error,
                        data,
                    });
                    outputErrors.push({
                        type: 'formulaValidation',
                        message: `Failed formula calculation for ${transformation.filterFormula}`,
                        row: meta.cursor,
                    });
                }
            },
            complete() {
                resolve({ outputData, outputErrors });
            } }));
    });
    const { outputData, outputErrors } = yield csvStreamPromise;
    return { errors: outputErrors, outputData };
});
const doTransform = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { srcDataTapeBuffer, transformation } = params;
    const inputCsvString = common_1.finleyBuffer.toString(srcDataTapeBuffer);
    const formulaEngine = (0, formula_engine_1.createFormulaEngine)(finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, [transformation.filterFormula]);
    const { errors, outputData } = yield processFilter({
        transformation,
        inputCsvString,
        formulaEngine,
    });
    if (errors.length) {
        return { isValid: false, errors };
    }
    const outputDataTape = getOutputDataTape(transformation);
    const outputBuffer = (0, helpers_1.rowDataToCsv)(outputData, outputDataTape);
    return { isValid: true, data: { outputBuffer }, supplementals: [] };
});
exports.default = {
    doTransform,
    getOutputDataTape,
};
//# sourceMappingURL=filter-transform.js.map